import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect';
import { useHotlineProDetailDataContext } from '@/feature/hotline/professional/detail/context/HotlineProDetailDataContext';
import { HotlineProFirstReplyConfirmPage } from '@/feature/hotline/professional/firstReply/confirm/page/HotlineProFirstReplyConfirmPage';
import { useHotlineProFirstReplyFormContext } from '@/feature/hotline/professional/firstReply/context/HotlineProFirstReplyFormContext';
import { useParams } from '@/hooks/lib/react-router/useParams';
import { pagePath } from '@/utils/router/pagePath';
/**
 * ホットライン 初回返信 確認画面
 * @description api データ取得を伴わないアクセス制限等を行う
 */
export const HotlineProFirstReplyConfirm = () => {
    const { id = '' } = useParams();
    const { formValues } = useHotlineProFirstReplyFormContext();
    const { detailData } = useHotlineProDetailDataContext();
    const detailOneData = detailData[id];
    // 詳細データや入力値がない場合は入力画面にリダイレクト
    if (!formValues || !detailOneData) {
        return (_jsx(CustomRedirect, { to: pagePath.hotline.professional.firstReplyInput(id) }));
    }
    return (_jsx(HotlineProFirstReplyConfirmPage, { formValues: formValues, id: id, title: detailOneData.title }));
};
